import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    title: "Composed, not manufactured",
    text: "Every Reserve 30 fragrance begins as a hand-weighed composition of fine French and Indian raw materials — never a diluted copy, never a shortcut.",
  },
  {
    title: "Matured like a reserve",
    text: "Each batch rests 8–10 weeks in darkness. Time rounds the edges, deepens the base, and binds the accord into a single, seamless signature.",
  },
  {
    title: "Worn as a mark",
    text: "Parfum-strength concentration engineered for projection, sillage and longevity. A Reserve 30 scent doesn't accompany you — it announces you.",
  },
];

export default function ManifestoSection() {
  return (
    <section id="experience" data-testid="experience-section" className="bg-[#EFE9E1] scroll-mt-20">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-24 md:py-36">
        <Reveal>
          <p className="overline-label">Experience</p>
          <h2 className="font-serif-brand text-4xl md:text-6xl font-light mt-4 max-w-2xl leading-tight">
            The Reserve 30 Experience
          </h2>
        </Reveal>
        <div className="mt-16 md:mt-24 space-y-0">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.1}>
              <div className="grid grid-cols-12 gap-6 py-10 md:py-14 border-t border-black/10 items-start">
                <span className="col-span-2 md:col-span-1 mt-3 block w-10 md:w-14 h-px bg-[#BA8D53]" />
                <h3 className="col-span-10 md:col-span-5 font-serif-brand text-2xl md:text-3xl font-light leading-snug">
                  {c.title}
                </h3>
                <p className="col-span-12 md:col-span-5 md:col-start-8 text-sm md:text-base text-black/60 leading-relaxed max-w-md">
                  {c.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
